import classNames from 'classnames'
import { useState } from 'react'
import { eventData, eventMapping } from './footer.tracking'
import { FooterV2Links } from './constants/footer-v2-links-config'
import FooterLinksWidget from './FooterLinksWidget'
import Text from '@/stories/components/Common/NewText'
import ArrowDown from '@/assets/common/arrowDown.inline.svg'
import { useAnalyticsEvent } from '@/hooks/analytics/use-analytics-event'

type TProps = {
  isInMobile?: boolean
}

const FooterSEOLinks = ({ isInMobile }: TProps) => {
  const [open, setOpen] = useState<string>('')
  const pushEvent = useAnalyticsEvent()

  const toggleLink = (title: string) => {
    const gtm4Payload = {
      eventData: {
        ...eventMapping[eventData.categoryClick],
        eventLabel: title,
      },
    }
    pushEvent({ gtm4Payload })
    if (open === title) {
      setOpen('')
    } else {
      setOpen(title)
    }
  }

  return (
    <div className="flex flex-col gap-4 lg:gap-8">
      {FooterV2Links.map((rows, index) => {
        return (
          <div key={index}>
            <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-4">
              {rows.rowsData.map((rowItem, index) => {
                return (
                  <div
                    className="flex flex-col"
                    key={`${index}-${rowItem.title}`}
                  >
                    <div
                      key={`${index}-${rowItem.title}`}
                      onClick={() => toggleLink(rowItem.title)}
                      className={classNames(
                        'hover:text-brand-grey-light flex cursor-pointer items-center justify-between gap-4 transition-colors duration-200 lg:justify-start',
                        {
                          'text-brand-grey-light': open === rowItem.title,
                          'text-brand-white': open !== rowItem.title,
                        },
                      )}
                    >
                      <Text appearance="subtitle1" tag="p">
                        {rowItem.title}
                      </Text>
                      <div
                        className={classNames(
                          'h-6 w-6 transition-transform duration-200',
                          {
                            'rotate-180': open === rowItem.title,
                          },
                        )}
                      >
                        <ArrowDown />
                      </div>
                    </div>

                    {isInMobile && (
                      <div
                        className={classNames({
                          hidden: open !== rowItem.title,
                          block: open === rowItem.title,
                        })}
                      >
                        <FooterLinksWidget
                          columnsData={rowItem.columnsData}
                          section={rowItem.title}
                        />
                      </div>
                    )}
                  </div>
                )
              })}
            </div>

            <div className="flex flex-col">
              {rows.rowsData.map((rowItem, index) => {
                if (isInMobile) return null
                return (
                  <div
                    key={`${index}-${rowItem.title}`}
                    className={classNames({
                      hidden: open !== rowItem.title,
                      block: open === rowItem.title,
                    })}
                  >
                    <FooterLinksWidget
                      columnsData={rowItem.columnsData}
                      section={rowItem.title}
                    />
                  </div>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default FooterSEOLinks
